import React from 'react';
import { getSuffix, pathJoin, slashTrim, withoutCaching } from 'utility';
import { config } from 'config';
import _ from 'lodash';
import SchemaForm, { sendFileAsBody } from '@restspace/schema-form';
import { useHistory } from 'react-router-dom';

export interface UploaderProps {
    path: string,
    operation: string,
    onUpload?: () => void,
    acceptedExtensions?: string[],
    showDownload?: boolean,
    messages?: [ string, string ],
    downloadQuery?: string
}


let apiUrl = config.api.apiUrl;
if (apiUrl.startsWith('/')) {
    apiUrl = pathJoin(window.location.protocol + '//' +  window.location.host, apiUrl);
}

export const Uploader = ({
    path, operation, onUpload, acceptedExtensions, showDownload, messages, downloadQuery
}: UploaderProps) => {
    const history = useHistory();
    showDownload = showDownload === undefined || showDownload;

    const filename = operation === 'new' ? null : _.last(slashTrim(path).split('/'));
    const schema = {
        type: 'object',
        properties: {
            file: {
                type: 'string',
                editor: 'upload',
                acceptedExtensions: acceptedExtensions || (filename ? [ getSuffix(filename) ] : null),
                title: operation === 'new'
                    ? (messages?.[0] || 'Upload a new file')
                    : (messages?.[1] || 'Replace this file with one of the same type')
            }
        }
    };

    const onUploaded = (newPath: string) => {
        if (path !== newPath) history.push('/' + newPath);
        if (onUpload) onUpload();
    }

    const componentContext = {
        uploadEditor: {
            getFileUrl: (file: File) => {
                const dest = pathJoin(apiUrl, path || '', operation === 'new' ? file.name : '');
                return dest;
            },
            sendFile: async (url: string, file: File, progress: (pc: number) => void) => {
                await sendFileAsBody(url, file, progress, "PUT");
                const newPath = operation === 'new' ? pathJoin(path || '', file.name) : path;
                onUploaded(newPath);
            },
            saveSiteRelative: true
        }
    };

    const downloadPath = path + (downloadQuery ? "?" + downloadQuery : "");
    return (
        <div className='uploader-container'>
            {showDownload && <>
                <h1>{filename}</h1>
                {filename && <a href={config.api.urlFromPath(downloadPath)} download={filename} className='jd-button'>Download</a>}
            </>}
            <SchemaForm
                schema={schema}
                value={{ file: operation === 'new' ? null : withoutCaching(pathJoin(apiUrl, path || '')) }}
                componentContext={componentContext}
                collapsible={true}
            />
        </div>
    );
}